/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budget_product';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async update(budgetId, productId, body) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${productId}`);
    return api.patch(url, body);
  },
  async inactivate(budgetId, productId) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${productId}`);
    return api.delete(url);
  }
};
